/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Usage_S41_Item_3Inputs */

const es_privacy_policy_usage_s41_item_3 = /** @type {(inputs: Privacy_Policy_Usage_S41_Item_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Busqueda y recuperacion de sus archivos conectados`)
};

const en_privacy_policy_usage_s41_item_3 = /** @type {(inputs: Privacy_Policy_Usage_S41_Item_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search and retrieval within your connected files`)
};

/**
* | output |
* | --- |
* | "Search and retrieval within your connected files" |
*
* @param {Privacy_Policy_Usage_S41_Item_3Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_usage_s41_item_3 = /** @type {((inputs?: Privacy_Policy_Usage_S41_Item_3Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Usage_S41_Item_3Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_usage_s41_item_3(inputs)
	return en_privacy_policy_usage_s41_item_3(inputs)
});
export { privacy_policy_usage_s41_item_3 as "privacy_policy.usage.s41_item_3" }